import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE = "caseirinho_cart";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(STORAGE)) || [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(STORAGE, JSON.stringify(items));
    }, [items]);

    function add(product, quantity = 1) {
        setItems((prev) => {
            const exists = prev.find((i) => i.product_id === product.id);
            if (exists) {
                return prev.map((i) =>
                    i.product_id === product.id ? { ...i, quantity: i.quantity + quantity } : i
                );
            }
            return [
                ...prev,
                {
                    product_id: product.id,
                    name: product.name,
                    price: product.price,
                    image: product.images?.[0],
                    producer_id: product.producer_id,
                    quantity,
                },
            ];
        });
    }

    function update(productId, quantity) {
        if (quantity <= 0) return remove(productId);
        setItems((prev) =>
            prev.map((i) => (i.product_id === productId ? { ...i, quantity } : i))
        );
    }

    function remove(productId) {
        setItems((prev) => prev.filter((i) => i.product_id !== productId));
    }

    function clear() {
        setItems([]);
    }

    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const count = items.reduce((s, i) => s + i.quantity, 0);

    return (
        <CartContext.Provider value={{ items, add, update, remove, clear, subtotal, count }}>
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
